import { render, staticRenderFns } from "./NbTabs.vue?vue&type=template&id=7bf1699d&scoped=true&"
import script from "./NbTabs.vue?vue&type=script&lang=js&"
export * from "./NbTabs.vue?vue&type=script&lang=js&"
import style0 from "./NbTabs.vue?vue&type=style&index=0&id=7bf1699d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1699d",
  null
  
)

export default component.exports